import { render, staticRenderFns } from "./GlobalDiffusionReport.vue?vue&type=template&id=324227f4&"
import script from "./GlobalDiffusionReport.vue?vue&type=script&lang=js&"
export * from "./GlobalDiffusionReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports